// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const TrendingUp = createIcon(
  <path
    clipRule="evenodd"
    d="M5 3C3.89543 3 3 3.89543 3 5V19C3 20.1046 3.89543 21 5 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H5ZM10.3354 6.83429C9.83831 6.8343 9.43537 7.23724 9.43538 7.7343C9.43538 8.23136 9.83833 8.6343 10.3354 8.63429L14.0601 8.63426L7.09818 15.5962C6.7467 15.9477 6.7467 16.5175 7.09818 16.869C7.44965 17.2205 8.0195 17.2205 8.37097 16.869L15.3329 9.90703L15.3329 13.6318C15.3329 14.1289 15.7359 14.5318 16.2329 14.5318C16.73 14.5318 17.1329 14.1289 17.1329 13.6318L17.1329 7.73424C17.1329 7.49554 17.0381 7.26662 16.8693 7.09784C16.7005 6.92905 16.4716 6.83423 16.2329 6.83424L10.3354 6.83429Z"
    fillRule="evenodd"
  />,
);
